/**
 * Create a FileList from an array of File objects.
 * @param {File[]} files
 * @returns {FileList}
 */
const createFileList = files => {
    const transfer = new DataTransfer();
    ( Array.isArray( files ) ? files : [] ).forEach( file => {
        if ( file instanceof File ) {
            transfer.items.add( file );
        }
    } );
    return transfer.files;
};

export default createFileList;
